import { styled } from "@mui/material/styles";
import { HubButton } from "../inputs";

export const StyledHubButton = styled(HubButton)({
  boxShadow: "none",
  padding: "4px 15px",
  fontSize: "10px",
  "&:hover": {
    boxShadow: "none"
  }
});
